import { useEffect } from 'react';

const BlockFileUpload: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const allowFileDrop = false;

  useEffect(() => {
    const handleDragOver = (event: DragEvent) => {
      event.preventDefault();
      event.dataTransfer!.dropEffect = 'none';
    };

    const handleDrop = (event: DragEvent) => {
      event.preventDefault();
    };

    // Add event listeners to the document body
    document.body.addEventListener('dragover', handleDragOver);
    document.body.addEventListener('drop', handleDrop);

    return () => {
      // Clean up event listeners
      document.body.removeEventListener('dragover', handleDragOver);
      document.body.removeEventListener('drop', handleDrop);
    };
  }, [allowFileDrop]);

  return children;
};

export default BlockFileUpload;
